// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 1px #606060;
  padding-top: 10px; }

.filter-subheader {
  background-color: #606060;
  color: white;
  padding-left: 20px; }
`, "",{"version":3,"sources":["webpack://./src/components/SessionFilterScreen/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB,EAAE;;AAErB;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB,EAAE","sourcesContent":[".filter-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: solid 1px #606060;\n  padding-top: 10px; }\n\n.filter-subheader {\n  background-color: #606060;\n  color: white;\n  padding-left: 20px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
